import { useState } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { Combobox } from "@similarweb/ui-components";

import type { CardType } from "app/pages/sales-intelligence/modules/manage-integrations/constants/cardTypes";
import { CARD_TYPE_LABEL_KEY } from "app/pages/sales-intelligence/modules/manage-integrations/constants/cardTypes";
import { MY_INTEGRATIONS_FILTER_ANY_TYPE } from "app/pages/sales-intelligence/modules/manage-integrations/constants/translations";

import { StyledCardFilterSimpleChip } from "./styles";

const ANY_TYPE_ID = "any-type";

interface IProps {
    availableTypes: readonly CardType[];
    selectedType: CardType | null;
    onChange: (type: CardType | null) => void;
}

const CardTypeFilterDropdown = ({ availableTypes, selectedType, onChange }: IProps): React.ReactElement => {
    const { translate } = useTranslate();
    const [isOpen, setIsOpen] = useState(false);

    const anyTypeLabel = translate(MY_INTEGRATIONS_FILTER_ANY_TYPE);
    const triggerLabel = selectedType ? translate(CARD_TYPE_LABEL_KEY[selectedType]) : anyTypeLabel;

    const handleSelect = (type: CardType | null) => {
        setIsOpen(false);
        onChange(type);
    };

    return (
        <Combobox
            placement="bottom-start"
            isOpen={isOpen}
            onOpenChange={setIsOpen}
            data-automation="my-integrations-type-filter"
        >
            <Combobox.Trigger>
                <StyledCardFilterSimpleChip
                    customIcon="arrow"
                    hideActionButton
                    text={triggerLabel}
                />
            </Combobox.Trigger>
            <Combobox.Content
                selectionMode="single"
                ariaLabel={anyTypeLabel}
            >
                <Combobox.Option
                    id={ANY_TYPE_ID}
                    textValue={anyTypeLabel}
                    isSelected={selectedType === null}
                    onClick={() => handleSelect(null)}
                >
                    <Combobox.OptionLabel>{anyTypeLabel}</Combobox.OptionLabel>
                </Combobox.Option>
                {availableTypes.map((type) => {
                    const label = translate(CARD_TYPE_LABEL_KEY[type]);

                    return (
                        <Combobox.Option
                            key={type}
                            id={type}
                            textValue={label}
                            isSelected={selectedType === type}
                            onClick={() => handleSelect(type)}
                        >
                            <Combobox.OptionLabel>{label}</Combobox.OptionLabel>
                        </Combobox.Option>
                    );
                })}
            </Combobox.Content>
        </Combobox>
    );
};

export default CardTypeFilterDropdown;
